
<div>
  @if (requestInProgress) {
    <p-progressSpinner></p-progressSpinner>
  } @else {
    <div class="manage-override-container">
      <form action="" [formGroup]="manageOverrideForm">
        <div class="datapoint">
          <label class="title">Data point: </label>
          <span class="dp-name">{{ manageOverrideForm.get("name")?.value }}</span>
        </div>

        <div class="new-data">
          <div class="new-value">
            <label>Change values to</label>

            @if (dataPoint?.signalType === BINARY) {
              <!-- FIX: reactive binding only -->
              <p-toggleswitch formControlName="value"></p-toggleswitch>
            } @else {
              @if (dataPoint.htmlSymbol === '°C') {
                <input
                  class="dp-value"
                  type="number"
                  formControlName="value"
                />
              } @else {
                <input
                  ccPreventDash
                  class="dp-value"
                  type="number"
                  min="0"
                  formControlName="value"
                />
              }
            }
          </div>

          <div class="duration">
            <label for="duration">Override Duration</label>
            <select
              name="durationType"
              formControlName="durationType"
              id="duration"
              [ariaPlaceholder]="''"
            >
              <option value="Permanently">
                Permanently
              </option>
              <option value="Timed">Timed</option>
            </select>
          </div>

          @if (durationType.value !== PERMANENTLY) {
            <div class="time-range">
              <label>For</label>
              <input
                type="number"
                placeholder="hhh"
                min="1"
                max="168"
                ccPreventDash
                formControlName="rollbackTimer"
              />
            <br />
            <span class="note-for-duration">
                *Minimum duration = 1 hour / Maximum duration = 168 hours
            </span>
            </div>
          }
        </div>

        <div class="result">
          <div class="cbms-api-response-feedback__message">
            @if (isFailed !== null) {
              <div class="title">
                @if (!isFailed) {
                  <span class="bold-text">
                    <mat-icon class="cbms-green-color small" svgIcon="success"></mat-icon>
                    Write Succeeded on property:
                    {{ manageOverrideForm.get("property")?.value }}
                    @if (manageOverrideForm.get('priority')?.value) {
                      with priority:
                      {{ manageOverrideForm.get("priority")?.value }}
                    }
                  </span>
                }
                @if (isFailed) {
                  <span class="bold-text">
                    <mat-icon class="cbms-red-color small" svgIcon="failure"></mat-icon>
                    Write setpoint not possible<br />
                  </span>
                  {{ manageOverrideForm.get("resultCode")?.value }}
                }
              </div>
            }
            <div class="dp-name"></div>
          </div>
        </div>
      </form>
    </div>

    <div class="footer">
      <button
        pButton
        class="p-button-raised button-turquoise-bg"
        (click)="updateDataPointValue()"
        [disabled]="!manageOverrideForm.valid"
      >
        SEND
      </button>
      <button
        pButton
        class="p-button-raised button-turquoise-bg"
        (click)="closeDialog()"
      >
        CLOSE
      </button>
    </div>
  }
</div>
